import { useParams } from "react-router-dom";
import { RollupDashboard } from "../../components/RollupDashboard";

export function GodownDashboard() {
  const { id } = useParams();
  return (
    <RollupDashboard
      scopeType="godown"
      scopeId={Number(id)}
      title={`Godown #${id}`}
      subtitle="Individual godown activity — RSTs, samples, verdicts."
    />
  );
}
